import React from 'react';

import DateUtils from 'util/DateUtils';

export default function TimeZoneNote({ intro = '' }) {

    const space = intro && intro.length > 0 ? <>&nbsp;</> : <></>;
    return (<span><small>({intro}{space}{DateUtils.getTimeZoneName()})</small></span>)
}